/**
 * Shared PCF etalon catalog for frontend autofill and option pickers.
 * Source of truth: merged from backend ObjectTypeEndTypeEtalonCatalog (etalon-first + missing rows).
 */

export interface EtalonEntry {
  objectType: string;
  skeyPattern: string;
  endType1: string;
  endType2: string;
  endType3: string;
  endType4?: string;
}

export interface EtalonEndTypes {
  end1?: string;
  end2?: string;
  end3?: string;
  end4?: string;
}

export interface EtalonOption {
  value: string;
  label: string;
}

const RAW_ETALON_ENTRIES: EtalonEntry[] = [
    {
        "objectType":  "IGNORE",
        "skeyPattern":  "",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BIP-IDENTIFIER",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BOLT",
        "skeyPattern":  "",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "ELBOW",
        "skeyPattern":  "ELBW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "END-CONNECTION-EQUIPMENT",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLSO",
        "endType1":  "LAP",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLWN",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE-BLIND",
        "skeyPattern":  "FLBL",
        "endType1":  "FL",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLOOR-SYMBOL",
        "skeyPattern":  "FLOR",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLOW-ARROW",
        "skeyPattern":  "FLOW",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "GASKET",
        "skeyPattern":  "",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "GASKET",
        "skeyPattern":  "GASK",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "INSTRUMENT",
        "skeyPattern":  "ID??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "ISO-SPLIT-POINT",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "LAPJOINT-STUBEND",
        "skeyPattern":  "FLSE",
        "endType1":  "LAP",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "LOCATION-POINT",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-CIRCLE",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-DIAMOND",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-DOUBLE-CIRCLE",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-ELLIPSE",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-ROUND",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-SQUARE",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MESSAGE-TRIANGLE",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "WTBW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "WTBW",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "BV",
        "endType4":  ""
    },
    {
        "objectType":  "PIPE",
        "skeyPattern":  "",
        "endType1":  "PL",
        "endType2":  "PL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-ECCENTRIC",
        "skeyPattern":  "REBW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-DIMENSION",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "BLD2",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "EQU2",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "FLR5",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "HST4",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "PIP4",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "VST4",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "WAL5",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REFERENCE-POINT",
        "skeyPattern":  "XXX4",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REINFORCEMENT-PAD",
        "skeyPattern":  "",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "START-CO-ORDS",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "DUCK",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "GUID",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "TAP-CONNECTION",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VB??",
        "endType1":  "SW",
        "endType2":  "SW",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VGFL",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VYFL",
        "endType1":  "WF",
        "endType2":  "WF",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "WELD",
        "skeyPattern":  "BV",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "ELBOW",
        "skeyPattern":  "EL??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "ELBOW",
        "skeyPattern":  "EB??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "ELBOW",
        "skeyPattern":  "ER??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "ELBOW",
        "skeyPattern":  "EU??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BEND",
        "skeyPattern":  "PB??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BEND",
        "skeyPattern":  "BE??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BEND",
        "skeyPattern":  "MI??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BEND",
        "skeyPattern":  "BU??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "TEE",
        "skeyPattern":  "TE??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "BV",
        "endType4":  ""
    },
    {
        "objectType":  "TEE",
        "skeyPattern":  "TY??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "BV",
        "endType4":  ""
    },
    {
        "objectType":  "TEE",
        "skeyPattern":  "BT??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "BV",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-CONCENTRIC",
        "skeyPattern":  "RC??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-CONCENTRIC",
        "skeyPattern":  "CPBW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-CONCENTRIC",
        "skeyPattern":  "CS??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-CONCENTRIC",
        "skeyPattern":  "RB??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-CONCENTRIC",
        "skeyPattern":  "CSCP",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-ECCENTRIC",
        "skeyPattern":  "RE??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "REDUCER-ECCENTRIC",
        "skeyPattern":  "ESBW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FILTER",
        "skeyPattern":  "FI??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FILTER",
        "skeyPattern":  "FA??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FILTER",
        "skeyPattern":  "FO??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "CROSS",
        "skeyPattern":  "CR??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "UNION",
        "skeyPattern":  "UN??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "COUPLING",
        "skeyPattern":  "CO??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "COUPLING",
        "skeyPattern":  "COSC",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "COUPLING",
        "skeyPattern":  "NR??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "COUPLING",
        "skeyPattern":  "NB??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "COUPLING",
        "skeyPattern":  "CSCP",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "CAP",
        "skeyPattern":  "KABW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "CAP",
        "skeyPattern":  "KASC",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "CAP",
        "skeyPattern":  "KASW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "CAP",
        "skeyPattern":  "KAGL",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "CAP",
        "skeyPattern":  "KAFP",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "NC??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "PL",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "BM",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "SB",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "SP",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "SR",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "PF",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "TI??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "ADMM",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "ADMF",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "MISC-COMPONENT",
        "skeyPattern":  "EX??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "NI??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "SKSW",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "TH??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "HC??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "OLET",
        "skeyPattern":  "LA??",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "INSTRUMENT",
        "skeyPattern":  "OP",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "INSTRUMENT",
        "skeyPattern":  "PR",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "INSTRUMENT",
        "skeyPattern":  "ITFL",
        "endType1":  "BV",
        "endType2":  "BV",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "INSTRUMENT",
        "skeyPattern":  "II??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FE??",
        "endType1":  "TC",
        "endType2":  "TC",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FOSO",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLSI",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLBL",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLSW",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLRC",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FOWN",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLF",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLLB",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLGM",
        "endType1":  "BV",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FRGL",
        "endType1":  "SC",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLFP",
        "endType1":  "SC",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLSC",
        "endType1":  "SC",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGE",
        "skeyPattern":  "FLCL",
        "endType1":  "CL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE-3WAY",
        "skeyPattern":  "V3??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "FL",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE-4WAY",
        "skeyPattern":  "V4??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "FL",
        "endType4":  "FL"
    },
    {
        "objectType":  "VALVE-ANGLE",
        "skeyPattern":  "AR??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE-ANGLE",
        "skeyPattern":  "CAFL",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE-ANGLE",
        "skeyPattern":  "RAR??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE-ANGLE",
        "skeyPattern":  "AV??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VY??",
        "endType1":  "WF",
        "endType2":  "WF",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "ZB??",
        "endType1":  "WF",
        "endType2":  "WF",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "CK??",
        "endType1":  "WF",
        "endType2":  "WF",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VC??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VD??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VT??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "11SP",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "12SP",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "14SP",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "15SP",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VU??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "CV??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VS??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VP??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VR??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "VG??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "VALVE",
        "skeyPattern":  "NV??",
        "endType1":  "FL",
        "endType2":  "FL",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "SUPP",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "O1HG",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "ANCH",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "SPRG",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "HANG",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "SKID",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SUPPORT",
        "skeyPattern":  "PSIG",
        "endType1":  "UNDEFINED_ET",
        "endType2":  "UNDEFINED_ET",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FIELD-WELD",
        "skeyPattern":  "WF",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FIELD-WELD",
        "skeyPattern":  "WS",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "WELD",
        "skeyPattern":  "WW",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "WELD",
        "skeyPattern":  "SO",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "WELD",
        "skeyPattern":  "WN",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "WELD",
        "skeyPattern":  "SJ",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "BUTTWELD",
        "skeyPattern":  "BW",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "SOCKET WELD",
        "skeyPattern":  "SW",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "GLUED",
        "skeyPattern":  "GL",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "THREADED",
        "skeyPattern":  "SC",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "FLANGED FITTING",
        "skeyPattern":  "FL",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "LINED FLANGE",
        "skeyPattern":  "LFL",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    },
    {
        "objectType":  "INSULATION_SYMBOL",
        "skeyPattern":  "",
        "endType1":  "",
        "endType2":  "",
        "endType3":  "",
        "endType4":  ""
    }
];

const GLOBAL_SKEY_PATTERNS = ['ID??', 'EQU2'];

function normalizeToken(value: string | undefined): string {
  return (value ?? '').trim().toUpperCase();
}

export function normalizeObjectTypeKey(value: string | undefined): string {
  return normalizeToken(value).replace(/[\s_]+/g, '-');
}

function matchesPattern(value: string, pattern: string): boolean {
  const normalizedValue = normalizeToken(value);
  const normalizedPattern = normalizeToken(pattern);
  if (!normalizedValue || !normalizedPattern) {
    return false;
  }

  const escapedPattern = normalizedPattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp('^' + escapedPattern.replace(/\\\*/g, '.*').replace(/\\\?/g, '.') + '$', 'i');
  return regex.test(normalizedValue);
}

function hasEndTypeExpectation(row: EtalonEntry): boolean {
  return Boolean(normalizeToken(row.endType1) || normalizeToken(row.endType2) || normalizeToken(row.endType3) || normalizeToken(row.endType4));
}

function patternSpecificity(pattern: string): number {
  return normalizeToken(pattern)
    .split('')
    .filter((character) => character !== '?' && character !== '*')
    .length;
}

function normalizeEntry(entry: EtalonEntry): EtalonEntry {
  return {
    objectType: normalizeObjectTypeKey(entry.objectType),
    skeyPattern: normalizeToken(entry.skeyPattern),
    endType1: normalizeToken(entry.endType1),
    endType2: normalizeToken(entry.endType2),
    endType3: normalizeToken(entry.endType3),
    endType4: normalizeToken(entry.endType4),
  };
}

export const PCF_ETALON_ENTRIES: EtalonEntry[] = RAW_ETALON_ENTRIES.map(normalizeEntry);

const entriesByObjectType = new Map<string, EtalonEntry[]>();
for (const row of PCF_ETALON_ENTRIES) {
  if (!row.objectType) continue;
  const bucket = entriesByObjectType.get(row.objectType) ?? [];
  bucket.push(row);
  entriesByObjectType.set(row.objectType, bucket);
}

const objectTypeValues = Array.from(entriesByObjectType.keys()).sort((a, b) => a.localeCompare(b));

const skeyPatternSet = new Set<string>();
for (const row of PCF_ETALON_ENTRIES) {
  if (row.skeyPattern) skeyPatternSet.add(row.skeyPattern);
}
for (const pattern of GLOBAL_SKEY_PATTERNS) {
  skeyPatternSet.add(pattern);
}
const skeyPatternValues = Array.from(skeyPatternSet).sort((a, b) => a.localeCompare(b));

const endTypeSet = new Set<string>();
for (const row of PCF_ETALON_ENTRIES) {
  if (row.endType1) endTypeSet.add(row.endType1);
  if (row.endType2) endTypeSet.add(row.endType2);
  if (row.endType3) endTypeSet.add(row.endType3);
  if (row.endType4) endTypeSet.add(row.endType4);
}

const symbolEndTypeObjects = new Set([
  'FIELD-WELD',
  'WELD',
  'BUTTWELD',
  'SOCKET-WELD',
  'GLUED',
  'THREADED',
  'FLANGED-FITTING',
  'LINED-FLANGE',
]);

for (const row of PCF_ETALON_ENTRIES) {
  if (symbolEndTypeObjects.has(row.objectType) && row.skeyPattern) {
    endTypeSet.add(row.skeyPattern);
  }
}

const endTypeValues = Array.from(endTypeSet).sort((a, b) => a.localeCompare(b));

export function getEtalonObjectTypes(): string[] {
  return objectTypeValues;
}

export function getSkeyPatternsForObjectType(objectType: string): string[] {
  const normalizedObjectType = normalizeObjectTypeKey(objectType);
  const rows = entriesByObjectType.get(normalizedObjectType) ?? [];
  const set = new Set<string>();
  for (const row of rows) {
    if (row.skeyPattern) set.add(row.skeyPattern);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}

export function hasOptionalSkeyPatternForObjectType(objectType: string): boolean {
  const normalizedObjectType = normalizeObjectTypeKey(objectType);
  const rows = entriesByObjectType.get(normalizedObjectType) ?? [];
  return rows.some((row) => !row.skeyPattern);
}

export function isSkeyRequiredForObjectType(objectType: string): boolean {
  const normalizedObjectType = normalizeObjectTypeKey(objectType);
  const rows = entriesByObjectType.get(normalizedObjectType) ?? [];
  if (rows.length === 0) {
    return false;
  }

  if (hasOptionalSkeyPatternForObjectType(normalizedObjectType)) {
    return false;
  }

  return rows.some((row) => Boolean(row.skeyPattern));
}

export function resolvePreferredEtalonSkey(objectType: string, skey: string): string | null {
  const normalizedObjectType = normalizeObjectTypeKey(objectType);
  const normalizedSkey = normalizeToken(skey);
  if (!normalizedObjectType || !normalizedSkey || !normalizedSkey.includes('?')) {
    return null;
  }

  const rows = entriesByObjectType.get(normalizedObjectType) ?? [];
  const matchingRows = rows
    .filter((row) => row.skeyPattern && matchesPattern(row.skeyPattern, normalizedSkey))
    .sort((left, right) => {
      const specificityDiff = patternSpecificity(right.skeyPattern) - patternSpecificity(left.skeyPattern);
      if (specificityDiff !== 0) return specificityDiff;

      const leftWildcardCount = (left.skeyPattern.match(/[?*]/g) ?? []).length;
      const rightWildcardCount = (right.skeyPattern.match(/[?*]/g) ?? []).length;
      return leftWildcardCount - rightWildcardCount;
    });

  return matchingRows[0]?.skeyPattern ?? null;
}

export function isKnownObjectType(objectType: string): boolean {
  return entriesByObjectType.has(normalizeObjectTypeKey(objectType));
}

export function isKnownSkey(skey: string): boolean {
  const normalizedSkey = normalizeToken(skey);
  if (!normalizedSkey) return false;

  return skeyPatternValues.some((pattern) => matchesPattern(normalizedSkey, pattern));
}

export function isSkeyAllowedForObjectType(objectType: string, skey: string, includeGlobalPatterns = true): boolean {
  const normalizedSkey = normalizeToken(skey);
  if (!normalizedSkey) return false;

  const objectPatterns = getSkeyPatternsForObjectType(objectType);
  if (objectPatterns.some((pattern) => matchesPattern(normalizedSkey, pattern))) {
    return true;
  }

  if (includeGlobalPatterns && GLOBAL_SKEY_PATTERNS.some((pattern) => matchesPattern(normalizedSkey, pattern))) {
    return true;
  }

  return false;
}

export function hasEtalonEndTypeExpectationForObjectType(objectType: string): boolean {
  const normalizedObjectType = normalizeObjectTypeKey(objectType);
  const rows = entriesByObjectType.get(normalizedObjectType) ?? [];
  return rows.some(hasEndTypeExpectation);
}

export function hasEtalonEndTypeExpectation(objectType: string, skey: string): boolean {
  return resolveEtalonEndTypes(objectType, skey) !== null;
}

export function resolveEtalonEndTypes(objectType: string, skey: string): EtalonEndTypes | null {
  const normalizedObjectType = normalizeObjectTypeKey(objectType);
  if (!normalizedObjectType) return null;

  const normalizedSkey = normalizeToken(skey);
  const rows = entriesByObjectType.get(normalizedObjectType) ?? [];
  if (rows.length === 0) return null;

  let candidateRows = rows.filter((row) => row.skeyPattern && matchesPattern(normalizedSkey, row.skeyPattern));
  if (candidateRows.length === 0) {
    candidateRows = rows.filter((row) => !row.skeyPattern);
  }

  candidateRows = candidateRows.filter(hasEndTypeExpectation);
  if (candidateRows.length === 0) {
    return null;
  }

  const selected = [...candidateRows]
    .sort((left, right) => {
      const specificityDiff = patternSpecificity(right.skeyPattern) - patternSpecificity(left.skeyPattern);
      if (specificityDiff !== 0) return specificityDiff;

      const filledLeft = [left.endType1, left.endType2, left.endType3, left.endType4].filter(Boolean).length;
      const filledRight = [right.endType1, right.endType2, right.endType3, right.endType4].filter(Boolean).length;
      return filledRight - filledLeft;
    })[0];

  return {
    end1: selected.endType1 || undefined,
    end2: selected.endType2 || undefined,
    end3: selected.endType3 || undefined,
    end4: selected.endType4 || undefined,
  };
}

export const ETALON_OBJECT_TYPE_OPTIONS: EtalonOption[] = [
  { value: '#PCF_OBJECT_TYPE', label: '#PCF_OBJECT_TYPE' },
  ...objectTypeValues.map((value) => ({ value, label: value })),
];

export const ETALON_SKEY_OPTIONS: EtalonOption[] = [
  { value: '#PCF_SKEY', label: '#PCF_SKEY' },
  ...skeyPatternValues.map((value) => ({ value, label: value })),
];

export const ETALON_END_TYPE_OPTIONS: EtalonOption[] = endTypeValues.map((value) => ({ value, label: value }));
